// extracted by mini-css-extract-plugin
export default {"wrapper":"TaskDescr_wrapper__txn6w","title":"TaskDescr_title__8y3dI","list":"TaskDescr_list__iQIy0"};